/**
 * Description: JS for domycreativewritings.com
 * Version: 1.0.0
 * Last update: 2015/04/01
 * Author: UVOCorp
 *
 */
/* Shim for deprecated uvoAutocomplete. Only modifies html layout for compatibility */
$.fn.uvoAutocomplete =
  $.fn.uvoAutocomplete ||
  function() {
    return this.each(function(_, el) {
      if (el.uvoAutocompleteShimInitialized) return;
      el.uvoAutocompleteShimInitialized = true;
      const $el = $(el);
      const $wrapper = $('<div class="uvo_pref-uvoAutocomplete-wrapper" />');
      const $icon = $(
        '<span class="ui-icon ui-icon-triangle-1-s" style="position: absolute; cursor: pointer; right: 10px; top: 0px;" />',
      );
      $el.wrap($wrapper);
      $el.after($icon);
      $el.addClass('uvo_pref-uvoAutocomplete-input');
      $el.css({ appearance: 'none', '::-ms-expand': 'none' });
      $icon.css({ pointerEvents: 'none' });
    });
  };

/* =============================
*  NEW CALC INIT
================================ */
$.getScript('/assets/js/calc.js', function() {
  // SHORT CALC
  if ($('[data-calc-short]').length > 0) {
    new Calc({
      ID: '81',
      calculatorType: 'ShortCalculator',
      format: 'json',
      environment: getEnvironment,
      options: {
        deafault: {
          deadlinesDefault: [115853, 115901, 115949, 116003, 116051],
          academicLevelDefault: 1,
          paperTypesDefault: 1,
          pagesDefault: 1,
        },
      },
    });
  }

  // CALC MINI
  if ($('[data-calc-mini]').length > 0) {
    new Calc({
      ID: '81',
      calculatorType: 'DefaultCalculator',
      format: 'html',
      environment: getEnvironment,
      options: {
        deafault: {
          deadlinesDefault: [69947],
          academicLevelDefault: 2,
          paperTypesDefault: 1,
          pagesDefault: 2,
        },
      },
    });
  }
});

(function(window, document) {
  function init() {
    const element = document.getElementById('CommonPage');

    if (element) {
      const pageName = element.getAttribute('data-page');
      const siteId = element.getAttribute('data-site-id');
      const policies = element.getAttribute('data-policies');
      const policyId = element.getAttribute('data-policy-id');

      let widgetOptions = {
        siteId,
        pageName,
      };

      if (policies && policyId) {
        widgetOptions = { siteId, pageName, policies, policyId };
      }

      window.commonPagesWidget.widget(element, widgetOptions);
    }
  }

  if (typeof window.commonPagesWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/commonPagesWidget.min.js';
    script.async = true;
    script.onload = function() {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);

/**
 * @license MIT, GPL, do whatever you want
 * @requires polyfill: Array.prototype.slice fix {@link https://gist.github.com/brettz9/6093105}
 */
if (!Array.from) {
  Array.from = function(object) {
    return [].slice.call(object);
  };
}

/*
   3.0. Toggle list
   ========================================================================== */
/**
 * Observer dom nodes
 * @param el - element for observe
 * @param callback - callback function after manipulation with el
 */
const observeEl = (el, callback) => {
  const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      callback(() => {
        mutationObserver.disconnect();
        return mutation;
      });
    });
  });

  if (document.querySelector(el)) {
    mutationObserver.observe(document.querySelector(el), {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true,
      attributeOldValue: true,
      characterDataOldValue: true,
    });
  }
};

// set event on toggle list items
document.addEventListener('DOMContentLoaded', function() {
  $(document).on('click', '.toggle-list .toggle-link', function() {
    if (
      $(this)
        .next()
        .hasClass('show')
    ) {
      $(this)
        .next()
        .slideUp(500);
      $(this)
        .next()
        .removeClass('show')
        .parent()
        .removeClass('active');
    } else {
      $(this)
        .next()
        .slideDown(500);
      $(this)
        .next()
        .addClass('show')
        .parent()
        .addClass('active');
    }
    return false;
  });
});

// remove unnecessary  block on money back guarantee
(() => {
  if ($('[data-page="money_back_guarantee"]').length > 0) {
    observeEl('#CommonPage', () => {
      if ($('.speech-to-user').length > 0) {
        $('.speech-to-user').remove();
      }
    });
  }
})();

$(function() {
  /*
     3.2. Add class "selected" for item select
     ========================================================================== */
  if ($.fn.uvoAutocomplete) {
    $('.place-your-order select').uvoAutocomplete({
      sortBy: 'none',
      onOpen(e) {
        const lebelEl = this.label;
        $(this._listElement.children()).each(function() {
          if ($(this).text() == lebelEl) {
            $(this).addClass('selected');
          }
        });
      },
    });
  }

  /*
     3.4. To-top link click
     ========================================================================== */

  $('.totop-link').click(function() {
    $('body,html').animate(
      {
        scrollTop: 0,
      },
      800,
    );
    return false;
  });

  /*
     3.5. Toggle Topmenu
     ========================================================================== */

  $('.toggle-menu').on('click', function() {
    $(this).toggleClass('active');
    if (
      $(this)
        .next()
        .css('display') == 'none'
    ) {
      $(this)
        .next()
        .show();
      $('.dropdown-link').removeClass('dropdown-link-toggle');
      $('.dropdown-link').on('click', function() {
        $('.dropdown-menu').toggleClass('dropdown-menu-open');
      });
    } else {
      $(this)
        .next()
        .hide();
      $('.dropdown-link').addClass('dropdown-link-toggle');
    }
    return false;
  });

  if ($('.topmenu-line').length > 0) {
    var tmenu = $('.topmenu-line');
    var tmenuTop = $('.topmenu-line').offset().top;
  }

  /*
     3.6. Fixed menu + Show To-top link
     ========================================================================== */

  $(window).scroll(function() {
    const scrlTopPos = $(window).scrollTop();
    const windowWidth = parseInt($(window).width()) + 17;
    if (windowWidth >= 968) {
      if (scrlTopPos <= tmenuTop) {
        $(tmenu).removeClass('fixed');
      } else if (scrlTopPos > tmenuTop) {
        $(tmenu).addClass('fixed');
      }
    }

    if ($(window).scrollTop() >= 200) {
      $('.totop-link').fadeIn();
    } else {
      $('.totop-link').fadeOut();
    }
  });

  /*
     3.8. For Inquiry page
     ========================================================================== */

  $('.show-hide')
    .find('.hidden')
    .hide();
  $('#inq-done-more').click(function() {
    if (!$(this).hasClass('less')) {
      $(this)
        .parents('.show-hide')
        .find('.hidden')
        .slideDown(500);
      $(this)
        .text('Read less')
        .addClass('less');
    } else {
      $(this)
        .parents('.show-hide')
        .find('.hidden')
        .slideUp(500);
      $(this)
        .text('Read more')
        .removeClass('less');
    }
  });

  /*
     3.9. Footer Site Links
     ========================================================================== */

  $('.footer-datalink').each(function(index) {
    const linkcurrent = $(this).attr('data-href');
    $(this).removeAttr('data-href');
    $(this).wrapInner(`<a href='${linkcurrent}' rel='nofollow'></a>`);
  });

  /*
     3.10. Calculate title
     ========================================================================== */

  $(window).on('load', function() {
    $('.calculateBlock > h2.title').html(function() {
      const htmlString = $(this).html();
      $(this).text('Prices for Essays');
    });
  });

  /*
     3.11. Price table cell hover td
     ========================================================================== */

  $('.writing-table tbody td:not(:first-child)')
    .mouseenter(function() {
      const tr = $(this).parent('.writing-table tbody tr');
      const Col = tr.find('td').index(this);
      const Span = $('.writing-table tbody tr').index(tr.get(0));
      tr.find(`td:lt(${Col})`).addClass('hover');
      $(`.writing-table tbody tr:lt(${Span})`)
        .find(`td:eq(${Col})`)
        .addClass('hover');
      $(this).addClass('hover-cell');
    })
    .mouseleave(function() {
      $('.writing-table tbody td').removeClass('hover-cell hover');
    });

  $('.price_table_default tbody td:not(:first-child)')
    .mouseenter(function() {
      const tr = $(this).parent('.price_table_default tbody tr');
      const Col = tr.find('td').index(this);
      const Span = $('.price_table_default tbody tr').index(tr.get(0));
      tr.find(`td:lt(${Col})`).addClass('hover');
      $(`.price_table_default tbody tr:lt(${Span})`)
        .find(`td:eq(${Col})`)
        .addClass('hover');
      $(this).addClass('hover-cell');
    })
    .mouseleave(function() {
      $('.price_table_default tbody td').removeClass('hover-cell hover');
    });
  $('.price_table_default tbody th')
    .mouseenter(function() {
      const tr = $(this).parent('.price_table_default tbody tr');
      const Col = tr.find('th').index(this);
      const Span = $('.price_table_default tbody tr').index(tr.get(0));
      tr.find(`th:lt(${Col})`).addClass('hover');
      $(`.price_table_default tbody tr:lt(${Span})`)
        .find(`th:eq(${Col})`)
        .addClass('hover');
      $(this).addClass('hover-cell');
    })
    .mouseleave(function() {
      $('.price_table_default tbody th').removeClass('hover-cell hover');
    });

  /*
     3.12. Grade tooltip
     ========================================================================== */

  const gradecode =
    "<ul class='grade-tooltip-body'><li><i>G</i>rowth</li><li><i>R</i>eliability</li><li><i>A</i>uthenticity</li><li><i>D</i>iversity</li><li><i>E</i>xcellence</li></ul>";

  $('.grade-tooltip')
    .mouseenter(function() {
      $(this).append(gradecode);
    })
    .mouseleave(function() {
      $('.grade-tooltip-body').remove();
    });
});

/*
   3.14. Sticky Block for Plagcheck Report
   ========================================================================== */

$(function() {
  if ($('body').find('.plagcheckc .report').length > 0) {
    (function($, win) {
      const requestFrame = (function() {
        const raf =
          win.requestAnimationFrame ||
          win.mozRequestAnimationFrame ||
          win.webkitRequestAnimationFrame ||
          function(fn) {
            return win.setTimeout(fn, 20);
          };
        return function(fn) {
          return raf(fn);
        };
      })();
      const { style } = win.document.body || win.document.documentElement;
      const prop = 'transition';
      const supportsTransition = typeof style[prop] === 'string';
      const events = {
        created: 'sticky-created',
        update: 'sticky-update',
        top: 'sticky-hit-top',
        bottom: 'sticky-hit-bottom',
        frozen: 'sticky-frozen',
        unfrozen: 'sticky-unfrozen',
      };
      const Sticky = function(elm, par, options) {
        this.element = elm;
        this.parent = par;
        this._frozen = false;
        this._stopped = true;
        this.options = $.extend(
          { useTransition: true, animate: true, animTime: 200, animDelay: 300 },
          options,
        );
        const offset = parseInt(options.offset, 10);
        this.options.offset = isNaN(offset) ? 0 : offset;
        this.init();
      };
      Sticky.prototype.init = function() {
        let transition = '';
        if (this.options.useTransition && supportsTransition) {
          transition = `top ${this.options.animTime}ms ease-in-out`;
          this.options.animate = false;
        }
        this.parent.css({ position: 'relative' });
        this.element.addClass('sticky-scroll').css({ transition, position: 'relative' });
        this.element.trigger(events.created);
        this.update();
      };
      Sticky.prototype.update = function() {
        this.setBoundaries(0);
        this.moveIt();
        this.element.trigger(events.update);
      };
      Sticky.prototype.moveIt = function() {
        const scrollTop =
          (win.document.documentElement.scrollTop || win.document.body.scrollTop) +
          this.options.offset;
        const height = this.element.outerHeight(true);
        const realStop = this._stop - height;
        if (this._parentHeight - this._offset > height && !this._frozen) {
          if (scrollTop >= this._start && scrollTop <= realStop) {
            this.updateOffset(scrollTop - this._start);
            this._stopped = false;
          } else if (scrollTop < this._start) {
            this.updateOffset(0);
            if (!this._stopped) {
              this.element.trigger(events.top);
            }
            this._stopped = true;
          } else if (scrollTop > realStop) {
            this.updateOffset(this._parentHeight - height - this._offset);
            if (!this._stopped) {
              this.element.trigger(events.bottom);
            }
            this._stopped = true;
          }
        }
      };
      Sticky.prototype.setBoundaries = function(offset) {
        this._offset = typeof offset === 'undefined' ? this.element.position().top : offset;
        this._start = this.parent.offset().top + this._offset;
        this._parentHeight = this.parent[0].offsetHeight;
        this._stop = this._start + this._parentHeight - this._offset;
      };
      Sticky.prototype.setOffset = function(newOffset) {
        newOffset = parseInt(newOffset, 10);
        if (!isNaN(newOffset)) {
          this.options.offset = newOffset;
          this.moveIt();
        }
      };
      Sticky.prototype.updateOffset = function(yOffset) {
        if (this._lastPosition !== yOffset) {
          if (this.options.animate) {
            this.element
              .stop(true, false)
              .delay(this.options.animDelay)
              .animate({ top: yOffset }, this.animTime);
          } else {
            this.element.css('top', yOffset);
          }
          this._lastPosition = yOffset;
        }
      };
      Sticky.prototype.toggleFreeze = function() {
        this._frozen = !this._frozen;
        this.element.stop(true, false);
        if (!this._frozen) {
          this.element.trigger(events.unfrozen);
          this.moveIt();
        } else {
          this.element.trigger(events.frozen);
        }
      };
      $.fn.sticky = function(parentName, options) {
        const method = parentName;
        let ret = false;
        this.each(function() {
          const self = $(this);
          let instance = self.data('stickyInstance');
          if (instance && (options || method)) {
            if (typeof options === 'object') {
              ret = $.extend(instance.options, options);
            } else if (options === 'options') {
              ret = instance.options;
            } else if (typeof instance[method] === 'function') {
              ret = instance[method].call(instance, options);
            } else {
              console.error(`Sticky Element has no option/method named ${method}`);
            }
          } else {
            let parent = null;
            if (parent) {
              parent = self.parent().closest(parent);
            } else {
              parent = self.parent();
            }
            instance = new Sticky(self, parent, options || {});
            self.data('stickyInstance', instance);
            $.fn.sticky._instances.push(instance);
          }
        });
        return ret || this;
      };
      const updateAll = function() {
        const len = $.fn.sticky._instances.length;
        for (let i = 0; i < len; i++) {
          $.fn.sticky._instances[i].update();
        }
      };
      $.fn.sticky._instances = [];
      $.fn.sticky.updateAll = updateAll;
      $(win).on({
        resize() {
          updateAll();
        },
        scroll() {
          const len = $.fn.sticky._instances.length;
          for (let i = 0; i < len; i++) {
            const element = $.fn.sticky._instances[i];
            if (!element._frozen) {
              element.moveIt();
            }
          }
        },
      });
      $(win.document).on({
        ready() {
          win.setInterval(function() {
            requestFrame(function() {
              const len = $.fn.sticky._instances.length;
              for (let i = 0; i < len; i++) {
                const element = $.fn.sticky._instances[i];
                if (element._parentHeight !== element.parent[0].offsetHeight) {
                  element.update();
                }
              }
            });
          }, 1e3);
        },
      });
    })(jQuery, window);

    $('.box_results').sticky('.little_form', {
      offset: 60,
    });
  }

  /*
   3.14. Sliders
   ========================================================================== */
  // $('.bxslider').bxSlider({
  //   mode:"fade",
  //   speed: 750,
  //   auto: true,
  //   controls: false,
  //   autoControls: false
  //
  // });

  // home slider
  const owlSlider = $('#home-slider');
  if (owlSlider.length > 0) {
    owlSlider.owlCarousel({
      items: 1,
      dots: true,
      autoplay: true,
      loop: true,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      transitionStyle: 'fade',
      touchDrag: false,
      mouseDrag: false,
    });

    const dots = $('.owl-dot');

    for (let i = 0; i < dots.length; i++) {
      const item = $(dots[i]).find('span')[0];
      $(item).attr('data-dot-number', i + 1);
    }
  }

  const testimonialsSlider = $('.testimonials-slider');
  if (testimonialsSlider.length > 0) {
    testimonialsSlider.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: false,
      smartSpeed: 450,
      items: 1,
      dots: true,
      autoplay: true,
      loop: true,
      transitionStyle: 'fade',
      touchDrag: false,
      mouseDrag: false,
    });
  }
});

(function(window, document) {
  function init() {
    window.NotifyWidget({
      siteId: '81',
      container: '.NotifyWidget-banner',
    });
  }

  if (typeof window.NotifyWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/notifyWidget.min.js';
    script.async = true;
    script.onload = function() {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);
